// import 'nprogress/nprogress.css'
// function loader(loading) {
//   if(instance && instance.$children) {
//     instance.$children[0].isLoading = loading
//   }
// }
const microApps = [{
  name: 'threeJs',
  entry: '//localhost:3002', //指定资源
  activeRule: '/subMain/sub-threeJs',
}, {
  name: 'pearlIsland',
  entry: '//localhost:5173',
  activeRule: '/subMain/pearlIsland'
}]
const apps = microApps.map(item => {
  return {
    ...item,
    container: '#sub-main',
  }
})
export default apps